import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { Row, Typography, Col, Spin, Form, Divider } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { apiConfig } from "../../../../customer.config";
import { BOM } from "../../../../../../services/definedMethod";
import { useLocation, useNavigate } from "react-router-dom";
import cnt from "../../../../../../services/definedConstant";
import CustomButton from "../../../../../../components/custom/CustomButton";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";

const { Text, Title } = Typography;

function ChannelServices(props) {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { currentCustomerObj, userData } = props;
  const { session } = userData;
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [accountLoading, setAccountLoading] = useState(false);

  // Service toggles state - array with id, status, disabled, and accounts
  const [activeServiceList, setActiveServiceList] = useState(0);
  const [serviceStates, setServiceStates] = useState([
    {
      id: 1,
      key: "cib",
      label: "Activate CIB",
      status: false,
      disabled: false,
      accounts: [],
    },
    {
      id: 2,
      key: "atmPos",
      label: "Activate ATM/POS",
      status: false,
      disabled: true,
      accounts: [],
    },
    {
      id: 3,
      key: "rib",
      label: "Activate RIB",
      status: false,
      disabled: true,
      accounts: [],
    },
    {
      id: 4,
      key: "ussd",
      label: "Activate USSD",
      status: false,
      disabled: true,
      accounts: [],
    },
  ]);

  console.log("serviceStates", serviceStates);
  // Clear active service if it becomes disabled
  useEffect(() => {
    const activeServiceState = serviceStates.find((s) => s.key === activeServiceList);
    if (activeServiceList && activeServiceState?.disabled) {
      setActiveServiceList(null);
    }
  }, [serviceStates, activeServiceList]);

  const getAccountOverviewList = useCallback(() => {
    const url = `${apiConfig.Clients}/${state.id}/accounts`;

    let body = {
      session,
    };

    setAccountLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setAccountLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempSavingsArray = [];

        objList?.savingsAccounts
          ?.filter((item) => item?.status?.active === true)
          ?.forEach((element) => {
            tempSavingsArray.push({
              ...element,
              key: element?.id,
              id: element?.id,
              accountNo: element?.accountNo ? element?.accountNo : "-",
              productName: element?.productName ? element?.productName : "-",
              displayName: `${element?.accountNo || "-"} - ${element?.productName || "-"}`,
              // Status flags for each service
              cibStatus: element?.cibStatus || false,
              atmPosStatus: element?.atmPosStatus || false,
              ribStatus: element?.ribStatus || false,
              ussdStatus: element?.ussdStatus || false,
            });
          });

        // Initialize accounts array for all services (all services share the same accounts)
        setServiceStates((prev) =>
          prev.map((service) => ({
            ...service,
            accounts: [...tempSavingsArray],
          }))
        );

        setAccountLoading(false);
      }
    });
  }, [state?.id, session]);

  useEffect(() => {
    if (currentCustomerObj?.id || state?.id) {
      getAccountOverviewList();
    }
  }, [currentCustomerObj?.id, state?.id, getAccountOverviewList]);

  const moveAccountToSelected = (serviceId, accountId) => {
    const service = serviceStates.find((s) => s.id === serviceId);
    if (!service) return;

    const statusKeyMap = {
      1: "cibStatus",
      2: "atmPosStatus",
      3: "ribStatus",
      4: "ussdStatus",
    };

    const statusKey = statusKeyMap[serviceId];
    if (!statusKey) return;

    setServiceStates((prev) =>
      prev.map((s) => ({
        ...s,
        accounts: s.accounts.map((acc) =>
          acc.id === accountId ? { ...acc, [statusKey]: true } : acc
        ),
      }))
    );
  };

  const moveAccountToAvailable = (serviceId, accountId) => {
    const service = serviceStates.find((s) => s.id === serviceId);
    if (!service) return;

    const statusKeyMap = {
      1: "cibStatus",
      2: "atmPosStatus",
      3: "ribStatus",
      4: "ussdStatus",
    };

    const statusKey = statusKeyMap[serviceId];
    if (!statusKey) return;

    setServiceStates((prev) =>
      prev.map((s) => ({
        ...s,
        accounts: s.accounts.map((acc) =>
          acc.id === accountId ? { ...acc, [statusKey]: false } : acc
        ),
      }))
    );
  };

  const getClientTemplate = useCallback(() => {
    const url = `${apiConfig.Clients}/template`;
    let body = {
      session,
    };
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        console.log(res);
      }
    });
  }, [session]);

  const getDetailById = useCallback(() => {
    setIsLoading(true);

    const url = `${apiConfig.Clients}/${state?.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      setIsLoading(false);
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setActiveServiceList(objDetail.flgChannel);
        setServiceStates((prev) =>
          prev.map((s) => ({ ...s, status: objDetail.flgChannel === s.id }))
        );
      }
    });
  }, [state?.id, session]);

  const updateCibAccounts = useCallback(() => {
    const cibService = serviceStates.find((s) => s.id === 1);
    const parsedAccounts =
      cibService?.accounts?.map((account) => ({
        accountId: account.id,
        cibStatus: account.cibStatus,
      })) || [];
    console.log(parsedAccounts);
    const url = `${apiConfig.Clients}/${state?.id}/accounts/cibstatus`;

    const body = {
      customerCibAccounts: parsedAccounts,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "PUT",
      session,
    };
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        setIsLoading(false);
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        } else {
          getDetailById();
          BOM.AlertMsg(
            cnt.SUCCESS,
            "Corporate Internet Banking accounts configuration saved successfully!"
          );
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          getDetailById();
          setIsLoading(false);
        },
      }
    );
  }, [state?.id, session, serviceStates, getDetailById, navigate]);
  const handleServiceToggle = (serviceKey) => {
    const selectedService = serviceStates.find((s) => s.id === serviceKey);
    const isAlreadyActive = selectedService?.status;

    const url = `${apiConfig.Clients}/${state.id}`;
    console.log("serviceKey", serviceKey, selectedService);
    const body = {
      flgChannel: isAlreadyActive ? 0 : serviceKey,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        setIsLoading(false);
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        } else {
          getDetailById();
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          getDetailById();
          setIsLoading(false);
        },
      }
    );
  };
  useEffect(() => {
    getDetailById();
    getClientTemplate();
  }, [getClientTemplate, getDetailById]);

  //   // Handle form submission
  //   console.log("Form values:", values);
  //   console.log("Service states:", serviceStates);

  //   // Mock implementation with loading and success message
  //   setIsLoading(true);

  //   // Simulate API call with delay
  //   const url = `${apiConfig.Clients}/template`;
  //   let body = {
  //     session,
  //   };
  //   BOM.FetchReqAction(body, url, (err, res) => {
  //     setIsLoading(false);

  //     if (err) {
  //       BOM.AlertMsg(cnt.DANGER, err);
  //     } else {
  //       BOM.AlertMsg(cnt.SUCCESS, "Channel services configuration saved successfully!");
  //       setIsLoading(false);
  //     }
  //   });
  //   // setTimeout(() => {
  //   //   BOM.AlertMsg(cnt.SUCCESS, "Channel services configuration saved successfully!");
  //   //   setIsLoading(false);
  //   // }, 1500);
  // };

  // Helper function to get status key based on service ID
  const getStatusKey = (serviceId) => {
    const statusKeyMap = {
      1: "cibStatus",
      2: "atmPosStatus",
      3: "ribStatus",
      4: "ussdStatus",
    };
    return statusKeyMap[serviceId];
  };

  const currentService = serviceStates.find((s) => s.id === activeServiceList);
  const statusKey = getStatusKey(activeServiceList);
  const allAccounts = currentService?.accounts || [];

  // Filter accounts based on status flag
  const currentServiceAccounts = {
    available: allAccounts.filter((acc) => !acc[statusKey]),
    selected: allAccounts.filter((acc) => acc[statusKey]),
  };

  console.log("serviceStates", serviceStates);
  return (
    <Spin spinning={isLoading || accountLoading} tip="Loading..." size="large">
      <div>
        <Title level={4} style={{ marginBottom: 40, fontWeight: "bold" }}>
          Channel Services
        </Title>

        {/* <Form form={form} layout="vertical" onFinish={onFinish}> */}
        {/* Activation Options Row */}
        <Row gutter={[24, 16]} style={{ marginBottom: 32 }}>
          {serviceStates.map((service) => {
            const isDisabled = service?.disabled || false;
            const isChecked = service?.status || false;

            return (
              <Col key={service.id}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    opacity: isDisabled ? 0.5 : 1,
                  }}
                >
                  <div
                    style={{
                      width: "25px",
                      height: "25px",
                      border: isChecked ? "none" : "1px solid #D1D5DB",
                      backgroundColor: isChecked ? "#92428B" : "#F3F4F6",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "12px",
                      transition: "all 0.2s",
                    }}
                    onClick={() => {
                      if (!isDisabled) {
                        handleServiceToggle(service.id);
                        setActiveServiceList(service.id);
                      }
                    }}
                  >
                    {isChecked ? (
                      <span style={{ color: "#fff", fontSize: "15px", fontWeight: "bold" }}>✓</span>
                    ) : (
                      <span style={{ color: "#9CA3AF", fontSize: "15px" }}>—</span>
                    )}
                  </div>
                  <Text
                    onClick={() => {
                      if (!isDisabled) {
                        setActiveServiceList(service.id);
                      }
                    }}
                    onMouseEnter={(e) => {
                      if (!isDisabled) {
                        e.currentTarget.style.color = "#92428B";
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isDisabled) {
                        e.currentTarget.style.color = "#000";
                      }
                    }}
                    style={{
                      fontSize: "16px",
                      cursor: isDisabled ? "not-allowed" : "pointer",
                      color: isDisabled ? "#9CA3AF" : "#000",
                      userSelect: "none",
                      transition: "color 0.2s",
                    }}
                  >
                    {service.label}
                  </Text>
                </div>
              </Col>
            );
          })}
        </Row>

        {/* Account Selection Panel */}
        {activeServiceList ? (
          <Row gutter={24}>
            {/* Available Accounts */}
            <Col span={12}>
              <div
                style={{
                  height: "500px",
                  // backgroundColor: "#FAFAFA",
                  borderRadius: "20px",
                  border: "1px solid #D1D5DB",
                  padding: "16px",
                }}
              >
                <Text strong style={{ fontSize: "16px", marginTop: "10px" }}>
                  Available Accounts
                </Text>
                <div style={{ marginTop: "20px", height: "90%", overflowY: "auto" }}>
                  {currentServiceAccounts?.available.length > 0 ? (
                    currentServiceAccounts?.available.map((account) => (
                      <div
                        key={account.id}
                        style={{
                          padding: "12px 0px",
                          marginBottom: "8px",
                          backgroundColor: "#fff",
                          // borderRadius: "8px",
                          borderBottom: "1px solid rgb(240, 240, 240)",
                          cursor: "pointer",
                          transition: "all 0.2s",
                        }}
                        onClick={() => moveAccountToSelected(activeServiceList, account.id)}
                        // onMouseEnter={(e) => {
                        //   // e.currentTarget.style.backgroundColor = "#F9FAFB";
                        //   e.currentTarget.style.borderColor = "#92428B";
                        // }}
                        // onMouseLeave={(e) => {
                        //   // e.currentTarget.style.backgroundColor = "#fff";
                        //   e.currentTarget.style.borderColor = "#E5E7EB";
                        // }}
                      >
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <Text style={{ fontSize: "14px", fontWeight: 500, marginBottom: "4px" }}>
                            {account.accountNo || "-"}
                          </Text>
                          <Text style={{ fontSize: "13px", color: "#6B7280" }}>
                            {account.productName || "-"}
                          </Text>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        // padding: "40px",
                        // margin: "auto",
                        width: "100%",
                        height: "100%",
                        textAlign: "center",
                        color: "#9CA3AF",
                        // backgroundColor: "#F9FAFB",
                        borderRadius: "4px",
                        // minHeight: "200px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Text>No available accounts</Text>
                    </div>
                  )}
                </div>
              </div>
            </Col>

            {/* Selected Accounts */}
            <Col span={12}>
              <div
                style={{
                  height: "500px",
                  // backgroundColor: "#FAFAFA",
                  borderRadius: "20px",
                  border: "1px solid #D1D5DB",
                  padding: "16px",
                }}
              >
                <Text strong style={{ fontSize: "16px", marginTop: "10px" }}>
                  Selected Accounts
                </Text>
                <div style={{ marginTop: "20px", height: "90%", overflowY: "auto" }}>
                  {currentServiceAccounts?.selected.length > 0 ? (
                    currentServiceAccounts?.selected.map((account) => (
                      <div
                        key={account.id}
                        style={{
                          padding: "12px 0px",
                          marginBottom: "8px",
                          backgroundColor: "#fff",
                          // borderRadius: "8px",
                          borderBottom: "1px solid rgb(240, 240, 240)",
                          cursor: "pointer",
                          transition: "all 0.2s",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          flexDirection: "col",
                        }}
                        // onMouseEnter={(e) => {
                        //   e.currentTarget.style.backgroundColor = "#F9FAFB";
                        //   e.currentTarget.style.borderColor = "#92428B";
                        // }}
                        // onMouseLeave={(e) => {
                        //   e.currentTarget.style.backgroundColor = "#fff";
                        //   e.currentTarget.style.borderColor = "#E5E7EB";
                        // }}
                      >
                        <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                          <Text style={{ fontSize: "14px", fontWeight: 500, marginBottom: "4px" }}>
                            {account.accountNo || "-"}
                          </Text>
                          <Text style={{ fontSize: "13px", color: "#6B7280" }}>
                            {account.productName || "-"}
                          </Text>
                        </div>
                        <DeleteOutlined
                          style={{
                            color: "#EF4444",
                            fontSize: "22px",
                            cursor: "pointer",
                            marginLeft: "12px",
                            marginRight: "12px",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            moveAccountToAvailable(activeServiceList, account.id);
                          }}
                        />
                      </div>
                    ))
                  ) : (
                    <div
                      style={{
                        // padding: "40px",
                        margin: "auto",
                        width: "100%",
                        height: "100%",
                        textAlign: "center",
                        color: "#9CA3AF",
                        // backgroundColor: "#F9FAFB",
                        borderRadius: "4px",
                        // minHeight: "200px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Text>No selected accounts</Text>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        ) : null}

        {activeServiceList ? (
          <Row style={{ marginTop: 24 }}>
            <Divider />
            {BOM.HasPermission("CREATE_ADDRESS") && (
              <CustomButton
                content="Submit"
                onClick={updateCibAccounts}
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />
            )}
            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={() => {}}
            />
          </Row>
        ) : null}
        {/* </Form> */}
      </div>
    </Spin>
  );
}

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ChannelServices);
